import React, { useState, ReactNode  } from "react";
import { Authentication, IAuthContext, User } from "Interfaces/AuthContext";
import { createContext } from "react";

import { signout } from 'Services/Authentication';

export const AuthContext = createContext<IAuthContext | undefined>(undefined)


export const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [user, setUser] = useState<User | null>(null)
    const [auth, setAuth] = useState<Authentication>({
        uid: '',
        auth: false,
        token: ''
    })

    const signIn = () => {

    }       

    const logout = () => {
        try {
            setUser(null)
            setAuth({
                uid: '',
                auth: false,
                token: ''
            })
            signout()
        } catch (error:any) {
            console.log(error.message)
        }
    }

    return (
        <AuthContext.Provider
            value={{
                user, setUser,
                auth, setAuth,
                signIn,
                logout
            }}>
            { children }
        </AuthContext.Provider>
    )
}